
import React, { Component } from "react";
import {
  Divider,
  Tag,
  Button,
  Modal,
  Avatar,
  Space,
  Tooltip,
  Table,
  Empty,
  Descriptions,
} from "antd";
import { withTranslation } from "react-i18next";
import {
  tagsBageStatus,
  tagsColorBalance,
  tagsTypeBage,
} from "../../helpers/tagsBage";
import moment from "moment";
import {
  DownOutlined,
  ExportOutlined,
  QuestionCircleFilled,
  UpOutlined,
} from "@ant-design/icons";
import { CopyTextToClipboard } from "../../helpers/copy";
import { calculateDaysUsed, convertMsToMinutes, formatPromptPayNumber } from "../../utils";

class DetailsBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tagetMore: false,
    };
  }
  // ฟังก์ชันช่วยเหลือสำหรับสร้าง Tag สถานะ
  renderStatusTag = (item) => {
    const { t, history } = this.props;
    const isPendingDevice = item?.status_bank === "PendingDevice";

    return (
      <Space size={"small"} style={{ columnGap: 0 }} wrap>
        <Tag color={tagsBageStatus(item?.status_bank)}>
          {item?.status_bank}
        </Tag>
        {isPendingDevice && (
          <Tooltip
          className="d-none"
            title={
              <Space>
                {t("เรียนรู้เพิ่มเติม")}
                <ExportOutlined
                  onClick={() => history.push("/KrungthaiBusinessGuide")}
                />
              </Space>
            }
            color="#0095ff"
          >
            <QuestionCircleFilled
              className="hover"
              onClick={() => history.push("/KrungthaiBusinessGuide")}
              style={{ fontSize: 15, cursor: "pointer", color: "#0000008a" }}
            />
          </Tooltip>
        )}
      </Space>
    );
  };

  // กำหนด Columns สำหรับตารางข้อมูลธนาคาร
  getBankColumns = () => {
    const { t } = this.props;
    return [
      {
        title: t("Bank Account"),
        key: "bank_account",
        render: (record) => {
          const imgUrl =
            record?.bank?.imageUrl ||
            `https://img2.pic.in.th/pic/noimage4x4.th.jpeg`;
          const txtCopy = `${record?.bank?.bank_id || ""} - ${record?.accountNumber || ""} - ${record?.accountName || ""}`;
          return (
            <div
              style={{ cursor: "copy" }}
              onClick={() => CopyTextToClipboard(txtCopy)}
            >
              <Avatar size={22} src={imgUrl} /> -{" "}
              <span style={{ fontWeight: "600" }}>
                {formatPromptPayNumber(record?.accountNumber)}
              </span>
              <br />
              <span className="text-muted d-block">{record?.accountName}</span>
            </div>
          );
        },
      },
      {
        title: t("account type"),
        dataIndex: "accountType",
        key: "accountType",
        render: (type) => <Tag color={tagsTypeBage(type)}>{t(type)}</Tag>,
      },
      {
        title: t("Balance"),
        dataIndex: "balance",
        key: "balance",
        render: (val) => (
          <span style={{ color: tagsColorBalance(val), fontWeight: "600" }}>
            {Intl.NumberFormat().format(val || 0)}
          </span>
        ),
      },
      {
        title: t("Status"),
        dataIndex: "status_bank",
        key: "status_bank",
        render: (status, record) =>
          status === "PendingDevice" && record?.bank?.bank_id === "ktb" ? (
            this.renderStatusTag(record)
          ) : (
            <Tag color={tagsBageStatus(status)}>{t(status)}</Tag>
          ),
      },
      {
        title: t("note"),
        dataIndex: "note",
        key: "note",
        render: (note) => (
          <div
            className="text-wrap"
            style={{ fontSize: "11px", maxWidth: 150 }}
          >
            {note || (
              <em style={{ color: "#888888b4" }}>
                <small>{t("No data")}</small>
              </em>
            )}
          </div>
        ),
      },
    ];
  };

  onCloseModel = () => {
    const { onClose } = this.props;

    this.setState({tagetMore: false}, () => onClose())

  }
  // กำหนด Columns สำหรับตารางรายการย้อนหลัง
  getTransactionColumns = () => {
    const { t } = this.props;
    return [
      {
        title: t("TXN Remark"),
        dataIndex: "name_bot",
        key: "name_bot",
        render: (val) => t(val),
      },
      {
        title: t("Date"),
        dataIndex: "created_at",
        key: "created_at",
        render: (date) => (
          <span title={moment(date).format("YYYY-MM-DD HH:mm")}>
            {moment(date).format("YYYY-MM-DD")}{" "}
            <strong style={{ fontWeight: "600" }}>
              {moment(date).format("HH:mm")}
            </strong>
          </span>
        ),
      },
      {
        title: t("Status"),
        dataIndex: "bot_status",
        key: "bot_status",
        render: (status) => <Tag color={tagsBageStatus(status)}>{status}</Tag>,
      },
      {
        title: t("transaction"),
        dataIndex: "getupdate_data",
        key: "getupdate_data",
        render: (val) => t("Deposit transactions", { transactions: val }),
      },
    ];
  };

  render() {
    const { open,  isData, t, resBankGroupData } = this.props;
    const { tagetMore } = this.state;

    

    // หาก Modal ปิดอยู่ หรือไม่มีข้อมูล ไม่ต้อง Render อะไร
    if (!open || !isData) return null;

    const arrData = [isData];
    const transactionData = Array.isArray(isData?.Botlog_limittimes)
      ? isData.Botlog_limittimes
      : [];
    const bankGroupData = Array.isArray(resBankGroupData)
      ? resBankGroupData
      : [];

    const findbankGroup = bankGroupData.find((o) => o.id === isData?.bankAccountGroupId);
    let bankGroup = findbankGroup?.name || t("No data");

    let accountpay_Type = isData?.accountType === "withdrawal" ? t("Default") : isData?.accountpay_Type

    const itemsDescriptions = [
      {
        key: "1",
        label: t("latestTransactionDateTime"),
        span: 3,
        children: <>{moment(isData?.latestTransactionDateTime).format("YYYY-MM-DD HH:mm:ss")}</>,
      },
      {
        key: "3",
        label: t("accountpay_Type"),
        span: 3,
        children: <>{accountpay_Type}</>,
      },
      {
        key: "4",
        label: t("Channel"),
        span: 3,
        children: <>{isData?.channel}</>,
      },
      {
        key: "5",
        label: t("Bank Group (ID)"),
        span: 3,
        children: <>{bankGroup} ({isData?.bankAccountGroupId})</>,
      },
      {
        key: "6",
        label: t("telephoneNumber"),
        span: 3,
        children: <>{isData?.telephoneNumber}</>,
      },
      {
        key: "7",
        label: t("Maximum account limit"),
        span: 3,
        children: <span style={{ color: tagsColorBalance(isData?.limit_Left), fontWeight: "500" }}>{isData?.limit_Left}</span>,
      },
      {
        key: "8",
        label: t("timeinterval"),
        span: 3,
        children: (
          <>
            {convertMsToMinutes(isData?.timeinterval_ms)} {t("mins")}
          </>
        ),
      },
      {
        key: "9",
        label: t("createdAt"),
        span: 3,
        children: <>{moment(isData?.created_at).format("YYYY-MM-DD HH:mm:ss")}</>,
      },
      
      {
        key: "10",
        label: t("updatedAt"),
        span: 3,
        children: <>{moment(isData?.updated_at).format("YYYY-MM-DD HH:mm:ss")}</>,
      },
      {
        key: "11",
        label: t("days used"),
        span: 3,
        children: <code style={{color: "blue"}}>{calculateDaysUsed(isData?.created_at)}</code>,
      },
    ];

    // const isPendingDevice = isData?.status_bank === "PendingDevice";

    return (
      <Modal
        width={765}
        open={open}
        onCancel={() => this.onCloseModel()}
        closable={true}
        maskClosable={false}
        style={{ top: 20 }}
        title={t("Details")}
        footer={[
          <Button key="close" onClick={() => this.onCloseModel()}>
            {t("close")}
          </Button>,
        ]}
      >
        {/* Bank Info */}

        <div className="body table-responsive" style={{ marginTop: 16 }}>
          <Table
            rowKey={(record) => record.accountNumber || "main-bank"}
            dataSource={arrData}
            columns={this.getBankColumns()}
            pagination={false}
            scroll={{ x: "max-content" }}
          />
        </div>
        {/* more info */}
        <Divider
          style={{ borderBlockStart: "0 transparent" }}
          orientation="right"
        >
          <Button
            iconPosition="end"
            icon={!tagetMore ? <DownOutlined /> : <UpOutlined />}
            type="default"
            onClick={() => this.setState({ tagetMore: !tagetMore })}
          >
            {!tagetMore ? t("Show More") : t("Hide")}
          </Button>
        </Divider>
        <Descriptions
          className={!tagetMore ? "d-none" : "animate"}
          bordered={true}
          title={null}
          size="small"
          items={itemsDescriptions}
        />

        {/* transactions */}
        <Divider orientation="left">
          {t("Recent transactions", { count: transactionData.length })}
        </Divider>
        <div className="body table-responsive">
          <Table
            rowKey={(record, index) => record.id || index}
            dataSource={transactionData}
            columns={this.getTransactionColumns()}
            pagination={false}
            scroll={{ x: "max-content" }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={t("No data")}
                />
              ),
            }}
          />
        </div>
      </Modal>
    );
  }
}

export default withTranslation()(DetailsBank);
